<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="card-body">
                  <div class="pb-0 text-start">
                    <h4 class="font-weight-bolder">Ingresar</h4>
                    <p class="mb-0">Ingrese su uaurio y contraseña</p>
                  </div>
                  <br />
                  <form role="form">
                    <div class="mb-3">
                      <input
                        type="text"
                        class="form-control lg"
                        v-model="usuario"
                        name="usuario"
                        id="usuario"
                        placeholder="usuario"
                      />
                    </div>
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <input
                          :type = "verpassword ? 'password' : 'text'"
                          class="form-control lg"
                          v-model="password"
                          name="password"
                          id="password"
                          placeholder="password"
                        />
                        <span class="input-group-text"
                          ><i type="button" class="fa" 
                          :class="{ 'fa-eye-slash': verpassword, 'fa-eye': !verpassword }"
                           @click="verclave()"></i
                        ></span>
                      </div>
                    </div>
                    <!-- <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="rememberMe"
                        id="rememberMe"
                        checked="ArgonSwitch"
                      />
                      <label class="form-check-label" for="id"
                        >Remember me</label
                      >
                    </div> -->
                    <div class="text-center">
                      <a
                        type="button"
                        @click="login()"
                        class="btn-info btn-lg mb-0 gradient mt-4"
                        >Iniciar Session</a
                      >
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <img
              style="background-size: cover;"
                        src="../assets/images/loginimagen.png"
                        class="h-100 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                        alt="user image"
                      />
              <!-- <div
                class="bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="
                  background-image: url('https://www.kindpng.com/picc/m/185-1854600_real-time-clock-logo-hd-png-download.png');
                  background-size: cover;
                "
              > -->
                <span class="mask opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >
                  SISTEMA DE TURNOS
                </h4>
                <p class="text-white position-relative">
                  Turnoro Digital para Optimizar el flujo del personal en sala,
                  reduzca los tiempos de espera, optener detallado en tiempo
                  real de sus oficinas.
                </p>
              <!-- </div> -->
            </div>
          </div>
           
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from "axios";
export default {
  name: "Home",
  components: {},
  data: function () {
    return {
      dialog: true,
      tab: 0,
      valid: true,
      usuario: "",
      password: "",
      verpassword: true,
      show1: false,
      token: "",
    };
  },
  methods: {
    verclave() {
      this.verpassword = !this.verpassword;
    },
    login() {
      this.$swal.fire({
        // title: 'Auto close alert!',
        html: "Cargando por favor espere.",
        // timer: 2000,
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      const tokenpeticion = {
        usuario: this.usuario,
        password: this.password,
      };
      axios.post("login", tokenpeticion).then((respuesta) => {
        if (respuesta.data.status == true) {
          this.token = respuesta.data.token;
          const datos = respuesta.data;
          sessionStorage.setItem("token", this.token);
          sessionStorage.setItem("nivel", datos.nivel);
          localStorage.setItem("nombre", datos.nombres);
          localStorage.setItem("usuario", datos.usuario);
          localStorage.setItem("documento", datos.cedula);
          localStorage.setItem("servicio", datos.servicio_utilizar);
          localStorage.setItem("modulo", datos.modulo_utilizar);
          localStorage.setItem("departamento", datos.departamento);
          localStorage.setItem("municipio", datos.municipio);
          localStorage.setItem("sede_usuario", datos.sede_usuario);
          sessionStorage.setItem(
            "departamento_nombre",
            datos.nombre_departamento
          );
          sessionStorage.setItem("municipio_nombre", datos.nombre_municipio);
          sessionStorage.setItem("sede_nombre", datos.nombre_sede);
          sessionStorage.setItem("servicio_nombre", datos.nombre_servicio);
          sessionStorage.setItem("servicio_nombre2", datos.nombre_servicio2);
          sessionStorage.setItem("modulo_nombre", datos.nombre);
          // ===============================================================
          localStorage.setItem("servicio2", datos.servicio_2);
          localStorage.setItem(
            "conteoservicio",
            datos.cantidad_llamar_servicio1
          );
          localStorage.setItem(
            "conteoservicio2",
            datos.cantidad_llamar_servicio2
          );
          localStorage.setItem("menosuno", datos.cantidad_llamar_servicio1);
          // ===============================================================
          this.$swal.fire(
            "Bienvenido",
            "Session Iniciada Correctamente",
            "success"
          );
          var date = new Date();
          localStorage.setItem(
            "hora",
            date.setTime(date.getTime() + 8 * 60 * 60 * 1000)
          ); // asignar horas
          // localStorage.setItem("hora",date.getTime() + 30*60000); //asignar minutos
          this.$router.push({ path: "/inicio" });
        } else {
          this.$swal.fire("Ups!!", "Usuario o Contraseña Incorrectos", "error");
        }
      });
    },
  },
};
</script>
<style scoped>

</style>